// @flow

import React from 'react';
import moment from 'moment';
import { Divider, Image, Label } from 'semantic-ui-react';
import MessagingIcon from '../../../../static/images/messaging-icon.svg';
import ItemContent from './ItemContent';
import type { ThreadMessage } from '../../types';
import type { Moment } from 'moment';

type Props = {
  message: ThreadMessage,
  isUnread: boolean,
  onDisplayMessage: (message: ThreadMessage, resource: BucketResource) => void,
};

const DAY_FORMAT: string = 'DD MMM YYYY';

const renderDay = (date: Moment): string => {
  if (date.isSame(moment(), 'day')) {
    return "Aujourd'hui";
  } else {
    return `Le ${date.format(DAY_FORMAT)}`;
  }
};

const Avatar = ({ message }) => {
  switch (message.direction) {
    case 'IN':
      return <Label circular content={message.nickname} />;
    case 'OUT':
      return <Image src={MessagingIcon} />;
    default:
      console.warn('Unknown message direction', message.direction);
      return null;
  }
};

const Content = ({ message, isUnread, onDisplayMessage }) => {
  return (
    <div className="message-container">
      <div className="message-avatar">
        <Avatar message={message} />
      </div>
      <ItemContent
        message={message}
        isUnread={isUnread}
        onDisplayMessage={onDisplayMessage}
      />
    </div>
  );
};

const Item = ({ message, isUnread, onDisplayMessage }: Props) => {
  const content = (
    <Content
      message={message}
      isUnread={isUnread}
      onDisplayMessage={onDisplayMessage}
    />
  );

  if (message.isFirstByDate) {
    return (
      <div data-index={message.index}>
        <Divider horizontal>{renderDay(message.date)}</Divider>
        {content}
      </div>
    );
  } else {
    return <div data-index={message.index}>{content}</div>;
  }
};

export default Item;



// WEBPACK FOOTER //
// ./src/modules/messaging/components/messages/Item.js